import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "token"
  ]

  copy(e) {
    e.preventDefault()
    navigator.clipboard.writeText(this.tokenTarget.textContent.trim())
    e.currentTarget.innerText = "Copié"
  }
}
